export default {"src":"https://fishbrain.com/_next/static/media/logo_small.0a55ae7a.svg","height":902,"width":1033,"blurWidth":0,"blurHeight":0};